export default __webpack_public_path__ + "static/media/hht2_sitcom_11.defd354a.png";